import { Dialog, DialogContent, DialogContentText, Grid, DialogActions, Button, Chip, Typography, TextField, AppBar, Toolbar } from "@mui/material"
import { useAppSelector } from "../../../../../hooks/store-hooks"
import { useClientesService } from "../../../../../../use-cases/clientes/useClientesService"
import CloseIcon from '@mui/icons-material/Close';



export const FormListaIp = () => {
  const vincularIpForm = useAppSelector((state) => state.clientes.vincularIPClienteForm)
  const {
    setClientesVincularIp,
    setVincularIpClienteFormIpValue,
    setAddVincularIpClienteFormIp,
    setRemoveVincularIpClienteFormIp,
    vincularIps
  } = useClientesService()
  const handleClose = () => {
    setClientesVincularIp({
      open: false
    })
  }
  return <>
    <Dialog
      open={true}
      fullScreen
      onClose={handleClose}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth={"lg"}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
            Vincular IP's
          </Typography>
          <Button
            color="inherit"
            startIcon={<>
              <CloseIcon />
            </>}
            onClick={handleClose}
            aria-label="close"
          >
            Fechar
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent dividers={true}>
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}></DialogContentText>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TextField
              value={vincularIpForm.fields.ipValue}
              onChange={(e) => {
                setVincularIpClienteFormIpValue(e.target.value)
              }}
              error={Boolean(vincularIpForm.touched && vincularIpForm.errors.find(item => item.key === 'ipValue'))}
              helperText={
                vincularIpForm.errors.find(item => item.key === 'ipValue')?.message
              }
              name="ip"
              fullWidth
              id="ip"
              label="Endereço IP"
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" onClick={() => {
              setAddVincularIpClienteFormIp()
            }}>
              Vincular
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>

                  Endereços IP vinculados
                </Typography>
              </Grid>
              {
                vincularIpForm.fields.ips.map((ip) => {
                  return <Grid item key={ip}>
                    <Chip label={ip} onDelete={() => {
                      setRemoveVincularIpClienteFormIp(ip)
                    }} />
                  </Grid>
                })
              }

            </Grid>
            <Grid item xs={12}>
              <Typography style={{
                marginTop: '10px'
              }} variant="caption">
                Total de IPs vinculados: {vincularIpForm.fields.ips.length}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={() => {
          vincularIps()
        }}>
          Atualizar lista de IPs
        </Button>
      </DialogActions>
    </Dialog>
  </>
}